<template>
  <div :class="container_class" :style="container_style">
    <multiselect
      @search-change="getCategories"
      v-model="category"
      @input="updateData"
      @remove="clearData"
      :loading="isLoading"
      :options="categories"
      :placeholder="placeholder"
      :clearOnSelect="false"
      :closeOnSelect="true"
      :preserveSearch="true"
      :searchable="true"
      :internal-search="false"
    >
      <template slot="singleLabel" slot-scope="props">
        <div>
          {{
          props.option.title
          }}
        </div>
      </template>
      <template slot="option" slot-scope="props">
        <div>
          {{
          props.option.title
          }}
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "category",
  components: {
    Multiselect
  },
  props: {
    place_holder: {
      type: String,
      default: ""
    },
    container_class: {
      type: String,
      default: "form-group skill-formdata home-form-group"
    },
    container_style: {
      type: String,
      default: "form-group skill-formdata"
    },
    categoryId: {
      type: [String, Number],
      default: null
	},
	length: {
		type: Number,
		default: 0
	}
  },
  data() {
    return {
      category: null,
      categories: [],
      placeholder: "Choose a category",
      isLoading: false,
      searchTimeOut: null
    };
  },
  created() {
      this.Label = this.label;
      if (
          this.place_holder != "" &&
          this.place_holder != null &&
          this.place_holder != undefined
      ) {
          this.placeholder = this.place_holder;
      }
	  this.isLoading = true
	  axios.get('/api/v1/category/default').then(res => {
		  this.categories = res.data.data
		  this.isLoading = false
	  });
  },
  methods: {
	getCategories(query,id){
		if(query.length >= this.length){
			this.isLoading = true;
			// console.log('query ',query)
			// console.log('id ',id)
			axios.post(`/api/v1/category/search`,{query}).then(res => {
				this.categories = res.data.data;
				this.isLoading = false
			})
		}
	},
    clearData: function() {
      this.$emit("input", null);
	},
	updateData(category){
        this.$emit("input", category.id);
		this.$parent.categoryId = category.id;
    }
  }
};
</script>
